import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { mqBuilder, MQ, mq } from 'utils/responsiveUtils'
import 'utils/fonts'
import 'scss/styles.scss'

let WebFont
if (typeof window !== `undefined`) {
  WebFont = require(`webfontloader`)
}

class Layout extends Component {
  state = {
    isFontsLoaded: false,
    orientation: ``,
    currentDevice: ``,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isDesktopLarge: false,
    isTouch: false,
    isMqSet: false,
  }

  componentDidMount () {
    this.$html = document.documentElement
    this.checkTouchSupport()
    this.checkDevice()
    this.loadFonts()
  }

  checkTouchSupport = () => {
    const detectTouch = () => {
      this.$html.classList.add(`-is-touch`)
      this.$html.removeEventListener(`touchend`, detectTouch)
      this.setState({isTouch: true})
    }
    this.$html.addEventListener(`touchend`, detectTouch)
  }

  checkDevice = () => {
    this.enquire = mqBuilder()
    this.checkDeviceOnResizeHandler()
    this.enquire.subscribeOnResize(this.checkDeviceOnResizeHandler)
  }

  checkDeviceOnResizeHandler = () => {
    const orientation = this.enquire.matches(`only screen and (orientation: portrait)`) ? `portrait` : `landscape`
    const isMobile = this.enquire.matches(MQ(mq.xxxs, mq.m))
    const isTablet = this.enquire.matches(MQ(mq.m, mq.l))
    const isDesktop = this.enquire.matches(MQ(mq.l, mq.xxxl))
    const isDesktopLarge = this.enquire.matches(MQ(mq.xxxl))
    const currentDevice = isMobile ? `mobile` : isTablet ? `tablet` : `desktop`
    this.setState({
      isMqSet: true,
      orientation,
      currentDevice,
      isMobile,
      isTablet,
      isDesktop,
      isDesktopLarge,
    })
  }

  loadFonts () {
    WebFont
      .load({
        google: {
          families: [`VT323`],
        },
        active: () => this.setState({isFontsLoaded: true})
      })
  }

  render () {
    const {children, data} = this.props
    return (<div>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content: 'I am a Creative Front-End Developer with 10 years of experience. I build websites with React Native, Vue, Nuxt, Phaser, Hapi, etc.'
          },
        ]}
      />
      {children({...this.props, ...this.state})}
    </div>)
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
    query SiteTitleQuery {
        site {
            siteMetadata {
                title
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js